import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import { getStationTitle } from 'utils/StationUtils'
import i18n from 'simple-react-i18n'
import QualityGraphicApp from 'quality/components/graphic/QualityGraphicApp'
import { useParams } from 'react-router'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'

const ProductionUnitAssociatedGraphic = () => {
    const { id } = useParams()

    const {
        productionUnit,
        prodUnitLinks,
    } = useSelector(store => ({
        productionUnit: store.ProductionUnitReducer.productionUnit,
        prodUnitLinks: store.ProductionUnitReducer.prodUnitLinks,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.productionUnit,
        href: 'productionUnit',
    }, {
        title: getStationTitle(productionUnit),
        href: `station/productionUnit/${id}`,
    }, {
        title: i18n.graphics,
        href: `station/productionUnit/${id}/graphic`,
    }], [productionUnit])

    const ids = useMemo(() => prodUnitLinks.filter(ass => ass.siteType === STATION_TYPE_CONSTANT.quality).map(ass => ass.siteCode), [prodUnitLinks])

    return (
        <QualityGraphicApp
            defaultStations={ids}
            hideStationsCriteria
        />
    )
}

export default ProductionUnitAssociatedGraphic